export const PECAI_API_URL = `${process.env.REACT_APP_PECAAI_URL}/sales-channels/v1`;
